import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSliders, faTimes, faUserFriends, faHardHat, faCalendar,
    faClock, faSearch, faCheckCircle, faFilterCircleXmark
} from '@fortawesome/free-solid-svg-icons';

const TimesheetAdvancedSearch = ({
    showAdvancedSearch,
    setShowAdvancedSearch,
    advancedFilters,
    setAdvancedFilters,
    employees,
    chantiers,
    resetAdvancedFilters,
    applyAdvancedFilters,
    activeFiltersCount
}) => {
    if (!showAdvancedSearch) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1001,
            padding: '2rem'
        }}>
            <div style={{
                background: 'var(--color-surface)',
                borderRadius: 'var(--border-radius-xl)',
                maxWidth: '600px',
                width: '100%',
                maxHeight: '90vh',
                overflowY: 'auto',
                boxShadow: 'var(--shadow-xl)'
            }}>
                {/* Header */}
                <div style={{
                    padding: '2rem 2rem 1rem',
                    borderBottom: '2px solid var(--color-light-gray)'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <FontAwesomeIcon icon={faSliders} style={{ color: '#3b82f6' }} />
                            Recherche Avancée
                        </h2>
                        <button
                            onClick={() => setShowAdvancedSearch(false)}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '1.5rem',
                                color: 'var(--color-text-light)',
                                padding: '8px'
                            }}
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>
                </div>

                {/* Form */}
                <div style={{ padding: '2rem' }}>
                    <div style={{ display: 'grid', gap: '1.5rem' }}>
                        {/* Employee Filter */}
                        <div>
                            <label style={{
                                display: 'block',
                                marginBottom: '0.5rem',
                                fontWeight: '600',
                                fontSize: '0.9rem'
                            }}>
                                <FontAwesomeIcon icon={faUserFriends} style={{ marginRight: '8px', color: '#3b82f6' }} />
                                Employé
                            </label>
                            <select
                                value={advancedFilters.employee}
                                onChange={(e) => setAdvancedFilters({ ...advancedFilters, employee: e.target.value })}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    border: '1px solid var(--color-light-gray)',
                                    borderRadius: 'var(--border-radius-md)',
                                    backgroundColor: 'var(--color-surface)',
                                    color: 'var(--color-text)'
                                }}
                            >
                                <option value="">Tous les employés</option>
                                {employees.map(emp => (
                                    <option key={emp} value={emp}>{emp}</option>
                                ))}
                            </select>
                        </div>

                        {/* Chantier Filter */}
                        <div>
                            <label style={{
                                display: 'block',
                                marginBottom: '0.5rem',
                                fontWeight: '600',
                                fontSize: '0.9rem'
                            }}>
                                <FontAwesomeIcon icon={faHardHat} style={{ marginRight: '8px', color: '#10b981' }} />
                                Chantier
                            </label>
                            <select
                                value={advancedFilters.chantier}
                                onChange={(e) => setAdvancedFilters({ ...advancedFilters, chantier: e.target.value })}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    border: '1px solid var(--color-light-gray)',
                                    borderRadius: 'var(--border-radius-md)',
                                    backgroundColor: 'var(--color-surface)',
                                    color: 'var(--color-text)'
                                }}
                            >
                                <option value="">Tous les chantiers</option>
                                {chantiers.map(ch => (
                                    <option key={ch} value={ch}>{ch}</option>
                                ))}
                            </select>
                        </div>

                        {/* Date Range */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '0.5rem',
                                    fontWeight: '600',
                                    fontSize: '0.9rem'
                                }}>
                                    <FontAwesomeIcon icon={faCalendar} style={{ marginRight: '8px', color: '#f59e0b' }} />
                                    Date de début
                                </label>
                                <input
                                    type="date"
                                    value={advancedFilters.dateFrom}
                                    onChange={(e) => setAdvancedFilters({ ...advancedFilters, dateFrom: e.target.value })}
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        border: '1px solid var(--color-light-gray)',
                                        borderRadius: 'var(--border-radius-md)',
                                        backgroundColor: 'var(--color-surface)',
                                        color: 'var(--color-text)'
                                    }}
                                />
                            </div>
                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '0.5rem',
                                    fontWeight: '600',
                                    fontSize: '0.9rem'
                                }}>
                                    <FontAwesomeIcon icon={faCalendar} style={{ marginRight: '8px', color: '#f59e0b' }} />
                                    Date de fin
                                </label>
                                <input
                                    type="date"
                                    value={advancedFilters.dateTo}
                                    onChange={(e) => setAdvancedFilters({ ...advancedFilters, dateTo: e.target.value })}
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        border: '1px solid var(--color-light-gray)',
                                        borderRadius: 'var(--border-radius-md)',
                                        backgroundColor: 'var(--color-surface)',
                                        color: 'var(--color-text)'
                                    }}
                                />
                            </div>
                        </div>

                        {/* Hours Range */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '0.5rem',
                                    fontWeight: '600',
                                    fontSize: '0.9rem'
                                }}>
                                    <FontAwesomeIcon icon={faClock} style={{ marginRight: '8px', color: '#8b5cf6' }} />
                                    Heures min
                                </label>
                                <input
                                    type="number"
                                    step="0.5"
                                    value={advancedFilters.hoursMin}
                                    onChange={(e) => setAdvancedFilters({ ...advancedFilters, hoursMin: e.target.value })}
                                    placeholder="0"
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        border: '1px solid var(--color-light-gray)',
                                        borderRadius: 'var(--border-radius-md)',
                                        backgroundColor: 'var(--color-surface)',
                                        color: 'var(--color-text)'
                                    }}
                                />
                            </div>
                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '0.5rem',
                                    fontWeight: '600',
                                    fontSize: '0.9rem'
                                }}>
                                    <FontAwesomeIcon icon={faClock} style={{ marginRight: '8px', color: '#8b5cf6' }} />
                                    Heures max
                                </label>
                                <input
                                    type="number"
                                    step="0.5"
                                    value={advancedFilters.hoursMax}
                                    onChange={(e) => setAdvancedFilters({ ...advancedFilters, hoursMax: e.target.value })}
                                    placeholder="24"
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        border: '1px solid var(--color-light-gray)',
                                        borderRadius: 'var(--border-radius-md)',
                                        backgroundColor: 'var(--color-surface)',
                                        color: 'var(--color-text)'
                                    }}
                                />
                            </div>
                        </div>

                        {/* Description Filter */}
                        <div>
                            <label style={{
                                display: 'block',
                                marginBottom: '0.5rem',
                                fontWeight: '600',
                                fontSize: '0.9rem'
                            }}>
                                <FontAwesomeIcon icon={faSearch} style={{ marginRight: '8px', color: '#ec4899' }} />
                                Description contient
                            </label>
                            <input
                                type="text"
                                value={advancedFilters.description}
                                onChange={(e) => setAdvancedFilters({ ...advancedFilters, description: e.target.value })}
                                placeholder="Rechercher dans les descriptions..."
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    border: '1px solid var(--color-light-gray)',
                                    borderRadius: 'var(--border-radius-md)',
                                    backgroundColor: 'var(--color-surface)',
                                    color: 'var(--color-text)'
                                }}
                            />
                        </div>

                        {/* Status Filter */}
                        <div>
                            <label style={{
                                display: 'block',
                                marginBottom: '0.5rem',
                                fontWeight: '600',
                                fontSize: '0.9rem'
                            }}>
                                <FontAwesomeIcon icon={faCheckCircle} style={{ marginRight: '8px', color: '#10b981' }} />
                                Statut
                            </label>
                            <select
                                value={advancedFilters.status}
                                onChange={(e) => setAdvancedFilters({ ...advancedFilters, status: e.target.value })}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    border: '1px solid var(--color-light-gray)',
                                    borderRadius: 'var(--border-radius-md)',
                                    backgroundColor: 'var(--color-surface)',
                                    color: 'var(--color-text)'
                                }}
                            >
                                <option value="">Tous les statuts</option>
                                <option value="pending">À valider</option>
                                <option value="approved">Validé</option>
                                <option value="rejected">Rejeté</option>
                            </select>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div style={{
                    padding: '1rem 2rem 2rem',
                    borderTop: '1px solid var(--color-light-gray)',
                    display: 'flex',
                    gap: '1rem',
                    justifyContent: 'flex-end'
                }}>
                    <button
                        onClick={resetAdvancedFilters}
                        style={{
                            padding: '12px 24px',
                            border: '1px solid var(--color-light-gray)',
                            borderRadius: '8px',
                            background: 'transparent',
                            color: 'var(--color-text)',
                            cursor: 'pointer',
                            fontWeight: '600',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}
                    >
                        <FontAwesomeIcon icon={faFilterCircleXmark} />
                        Réinitialiser
                    </button>
                    <button
                        onClick={applyAdvancedFilters}
                        style={{
                            padding: '12px 24px',
                            border: 'none',
                            borderRadius: '8px',
                            background: '#3b82f6',
                            color: 'white',
                            cursor: 'pointer',
                            fontWeight: '600',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}
                    >
                        <FontAwesomeIcon icon={faSearch} />
                        Appliquer ({activeFiltersCount})
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TimesheetAdvancedSearch;
